let suppressScrollResetUntil = 0;

export function markEntityNavigationInProgress(holdMs = 1000) {
  suppressScrollResetUntil = Date.now() + holdMs;
}

export function shouldSuppressEntityNavigationScrollReset() {
  return Date.now() < suppressScrollResetUntil;
}
